/**
 * Lazy Module Loader
 *
 * Dynamically imports JS modules only when their corresponding
 * DOM elements are present on the page.
 *
 * This keeps the initial bundle small and loads functionality on demand.
 */

/**
 * Module registry.
 * Each entry maps a CSS selector to a dynamic import.
 */
const MODULE_REGISTRY = [
    // Example: Accordion module, loaded only when .hf-accordion exists
    // {
    //     selector: '.hf-accordion',
    //     loader: () => import(/* webpackChunkName: "accordion" */ './accordion'),
    //     init: (module) => module.initAccordion(),
    // },
    // Example: Slider module
    // {
    //     selector: '.hf-slider',
    //     loader: () => import(/* webpackChunkName: "slider" */ './slider'),
    //     init: (module) => module.initSlider(),
    // },
];

/**
 * Initialize lazy-loaded modules.
 * Scans the DOM for registered selectors and loads modules dynamically.
 */
export async function initLazyModules() {
    const loadPromises = MODULE_REGISTRY
        .filter(({ selector }) => document.querySelector(selector))
        .map(async ({ selector, loader, init }) => {
            try {
                const module = await loader();
                init(module);
            } catch (error) {
                console.error(
                    `[Highfive FSE] Failed to load module for "${selector}":`,
                    error
                );
            }
        });

    await Promise.allSettled(loadPromises);
}
